import {BTTrackerBase} from './base';

const PIXEL_BASE_URL = 'https://trkn.us/pixel/c';

export class AudacyTracker extends BTTrackerBase {
  configure({audacy = {}, ...restConfig}, ...restArgs) {
    super.configure({audacy, ...restConfig}, ...restArgs);
    this.audacyProjectID = audacy?.projectId;

    if (!this.audacyProjectID) {
      this.disable();
      this.log('Audacy has been disabled because no projectId was specified in the settings.', {settings: audacy});
    }
  }

  getName() {
    return 'AudacyTracker';
  }

  get requiresTrackingConsent() {
    return true;
  }

  get restrictsEventsWithoutConsent() {
    return true;
  }

  view(...params) {
    if (!super.view(...params)) {
      return false;
    }

    this.loadImagePixel({g: 'sitewide', gid: '57776'});

    // when we're on the landing page (redirected from www.biotrust.com/jen), fire the landing_page pixel
    if (window.location.pathname === '/pages/ageless-muscle-drr-1414') {
      this.loadImagePixel({g: 'landing_page', gid: '57777'});
    }

    return true;
  }

  purchase(order, items, {addon} = {}) {
    if (!super.purchase(order, items, {addon})) {
      return false;
    }

    if (addon) {
      this.log('Audacy conversion tracker will not fire for an add-on to an existing order', {
        order,
        addon,
      });
      return false;
    }

    if (!order) {
      this.log('Audacy conversion tracker will not fire because the order is missing', order);
      return false;
    }

    const queryParams = {
      g: 'purchase',
      gid: '57778',
      cv1: order.id,
      rev: (order.subtotal + order.shipping).toFixed(2),
    };

    this.loadImagePixel(queryParams);
    return true;
  }

  getImagePixelUrl(queryParams) {
    const url = new URL(PIXEL_BASE_URL);
    url.search = new URLSearchParams(queryParams).toString();
    return url.href;
  }

  loadImagePixel(queryParams) {
    const pixel = new Image(1, 1);
    pixel.src = this.getImagePixelUrl({
      ...queryParams,
      ppt: `${this.audacyProjectID}`,
      ord: Math.random().toString(),
    });
    document.body.appendChild(pixel);

    this.log('Loading pixel', {src: pixel.src});
  }
}
